import { useMemo } from "react";
import { useCustomerPhonePermissions } from "./use-permissions";
import { maskPhone } from "../../modules/home/v1/utils/mask-phone";
import { getCurrentUserId } from "../../infra/firebase/init";

interface UseMaskedIdentityProps {
  name?: string;
  phoneNumber?: string;
}

/**
 * Returns name and phone number adjusted based on user’s phone read permissions.
 */
export const useMaskedIdentity = ({ name, phoneNumber }: UseMaskedIdentityProps) => {
  const currentUserId = getCurrentUserId();
  const { getPhonePermissions } = useCustomerPhonePermissions();
  const hasAccessToReadPhone = getPhonePermissions(currentUserId as string).canRead;

  const { nameToRender, phoneNumberToRender } = useMemo(() => {
    if (hasAccessToReadPhone) {
      return {
        nameToRender: name ?? '',
        phoneNumberToRender: phoneNumber ?? '',
      };
    }

    const maskedNumber = phoneNumber ? maskPhone(phoneNumber, 'X') : '';
    const maskedName =
      (name && name === phoneNumber) ? maskedNumber : name ?? '';

    return {
      nameToRender: maskedName,
      phoneNumberToRender: maskedNumber,
    };
  }, [name, phoneNumber, hasAccessToReadPhone]);

  return { nameToRender, phoneNumberToRender, hasAccessToReadPhone };
};
